module.exports = __webpack_public_path__ + "975e9e3761e3e8390d606f91210f8717.glb";